"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatternValueGroups = exports.flatternValueGroupsForIndex = void 0;
const value_group_1 = require("../value-group");
/**
 * Flatten a {@link ValueGroup} with `number[]` into `number`.
 * This is done by taking the value at the given {@link index}.
 */
const flatternValueGroupsForIndex = (groups, index) => {
    return (0, value_group_1.recreateWithTotalForValueGroup)(groups.map((x) => {
        return {
            index: x.index,
            total: x.total[index],
            items: x.items.map((xx) => {
                return {
                    index: xx.index,
                    value: xx.value[index],
                };
            }),
        };
    }));
};
exports.flatternValueGroupsForIndex = flatternValueGroupsForIndex;
/**
 * Flatten a {@link ValueGroup} with `number[]` into `number`.
 *
 * This is done by taking the first value from each array.
 * This value should be the total entry.
 *
 * @deprecated use {@link flatternValueGroupsForIndex} directly.
 */
const flatternValueGroups = (groups) => {
    return (0, exports.flatternValueGroupsForIndex)(groups, 0);
};
exports.flatternValueGroups = flatternValueGroups;
